import { UPDATE_REDUX_ENROLLMENT_STATUS } from '../constants/actionTypes';
import { getListingDetailsApi, setEnrollmentStatusApi } from '../utils/api';
import { enrollmentLoadingStatusUpdate } from './loadingStatusActionCreators';
import { getGlobalLogger } from '@zg-rentals/logger-base';
import { logError } from '@zg-rentals/log-error';
const logger = getGlobalLogger(__filename);

export function updateReduxEnrollmentStatus(payload) {
  return { type: UPDATE_REDUX_ENROLLMENT_STATUS, payload };
}

const getUpdatedEnrollmentStatus = (payload) => (dispatch) => {
  dispatch(enrollmentLoadingStatusUpdate({ enrollmentLoading: true }));
  dispatch(getListingDetailsApi(payload)).then(
    (response = {}) => {
      if (response && response.data && response.data.response) {
        const enrollmentOn = response.data.response.applicationsAccepted;
        dispatch(updateReduxEnrollmentStatus({ enrollmentOn }));
      } else {
        logger.info('Failed to get listing details.', response);
      }

      dispatch(enrollmentLoadingStatusUpdate({ enrollmentLoading: false }));
    },
    (serverError) => {
      logError({ error: serverError.message || serverError, context: 'Failed to get listing details' });
      dispatch(enrollmentLoadingStatusUpdate({ enrollmentLoading: false }));
    },
  );
};

const setEnrollmentStatus = (payload) => (dispatch) => {
  dispatch(setEnrollmentStatusApi(payload)).then(
    (response = {}) => {
      if (response && response.data && response.data.success) {
        dispatch(updateReduxEnrollmentStatus({ enrollmentOn: payload.applicationsAccepted }));
      } else {
        logger.info('Failed to set enrollment status.', response);
      }
    },
    (serverError) => {
      logError('Failed to set enrollment status. Error: ', serverError.message || serverError);
    },
  );
};

export { getUpdatedEnrollmentStatus, setEnrollmentStatus };
